export default __webpack_public_path__ + "static/media/hr.5d5158eb.png";